/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsApplicationSortCriteria {
    getFixupPrototypeFunction() { return AppSecopsApplicationSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsApplicationSortCriteria>): AppSecopsApplicationSortCriteria {
        let obj = Object.assign(new AppSecopsApplicationSortCriteria(), model);
        AppSecopsApplicationSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsApplicationSortCriteria>): AppSecopsApplicationSortCriteria {
        if (!model) return null;
        return AppSecopsApplicationSortCriteria.newInstance(<AppSecopsApplicationSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsApplicationSortCriteria) {
        if (!obj) return;

        models.AppSecopsApplicationSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsApplicationSortCriteria): boolean {
        Object.setPrototypeOf(obj, AppSecopsApplicationSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.AppSecopsApplicationSortColumn;

    ascending: boolean;

}
